export default "__VITE_ASSET__CA3UfSd3__"